// extracted by mini-css-extract-plugin
module.exports = {"background":"Soluciones_background__3snQf","card":"Soluciones_card__M1fbA"};